import React, { useMemo } from "react"
import { Box, FormControl, FormHelperText, FormLabel, Skeleton, Slider, Typography } from "@mui/material"
import { getCurrencyStringFromNumber } from "../../Util/Util"

const DimensionSlider = ({ title, option, options, updateOptions, orderData, isStaff, showPrice }) => {
  const marks = useMemo(() => {
    if (!options?.length) return []
    return options
      .map((o) => ({ value: o.extra_data.total_inches, label: o.value }))
      .sort((a, b) => a.value - b.value)
  }, [options])

  if (!option || !marks.length) return <Skeleton />

  const min = marks[0].value
  const max = marks[marks.length - 1].value
  const current = option?.extra_data?.total_inches ?? min
  const disabled = orderData?.locked && !isStaff

  return (
    <Box my={1}>
      <FormControl fullWidth>
        <FormLabel>
          <Typography variant="caption">{title}</Typography>
        </FormLabel>
        <Box px={1} pt={4}>
          <Slider
            value={current}
            min={min}
            max={max}
            step={null}
            marks={marks}
            disabled={disabled}
            valueLabelDisplay="on"
            valueLabelFormat={(v) => {
              const match = options.find((o) => o.extra_data.total_inches === v)
              return match?.value ?? String(v)
            }}
            onChange={(_, val) => {
              const match = options.find((o) => o.extra_data.total_inches === val)
              if (match) updateOptions([match])
            }}
            sx={{
              color: "#c8b99a",
              "& .MuiSlider-markLabel": { display: "none" },
              "& .MuiSlider-valueLabel": {
                fontFamily: "'Josefin Sans', sans-serif",
                fontSize: "0.7rem",
                bgcolor: "rgba(255,255,255,0.12)",
                color: "#fff",
              },
              "& .MuiSlider-thumb": { width: 14, height: 14 },
            }}
          />
        </Box>
        {showPrice && option?.price > 0 && (
          <Typography variant="caption" sx={{ fontFamily: "'Josefin Sans', sans-serif", color: "#c8b99a", pl: 1 }}>
            {getCurrencyStringFromNumber(option.price, true)}
          </Typography>
        )}
        {option?.help_text && (
          <FormHelperText sx={{ textAlign: "center" }}>{option.help_text}</FormHelperText>
        )}
      </FormControl>
    </Box>
  )
}

export default DimensionSlider
